import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AppState } from '@app/reducers';
import { CrudService, CrudType, LoggedInUserModel, ModulesBasedApiSuffix, ReusablePrimeNGTableFeatureService, SnackbarService, addDefaultTableObjectProperties, checkUserPermissionsByCategory, currentComponentPageBasedPermissionsSelector$, onActionSubmittedUtil, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams } from '@app/shared';
import { RxjsService } from '@app/shared/services';
import { IApplicationResponse } from '@app/shared/utils/interfaces.utils';
import { loggedInUserData } from '@modules/others';
import { IT_MANAGEMENT_COMPONENT, UserModuleApiSuffixModels } from '@modules/user/shared';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../shared/models/prime-ng-table-list-component-variables.model';
import { CityAddEditComponent } from './';
@Component({
  selector: 'app-city-list',
  templateUrl: './city.component.html',
})

export class CityListComponent extends PrimeNgTableVariablesModel implements OnInit {

  constructor(
    private dialog: MatDialog,
    private crudService: CrudService,
    private snackbarService: SnackbarService,
    private store: Store<AppState>,
    private reusablePrimeNGTableFeatureService: ReusablePrimeNGTableFeatureService,
    private rxjsService: RxjsService) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "City",
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'IT Management ', relativeRouterUrl: '' }, { displayName: 'City List' }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'City',
            dataKey: 'cityId',
            enableAction: true,
            enableStatusActiveAction: true,
            columns: [{ field: 'cityName', header: 'City' },
            { field: 'countryName', header: 'Country' },
            { field: 'provinceName', header: 'Province' },
            { field: 'createdDate', header: 'Created Date', isDate: true },
            { field: 'isActive', header: 'Status' }
            ],
            apiSuffixModel: UserModuleApiSuffixModels.CITIES,
            moduleName: ModulesBasedApiSuffix.IT_MANAGEMENT
          }]
      }
    }
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties);
  }

  ngOnInit() {
    this.combineLatestNgrxStoreData();
    this.getCities();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      let permission = response[1][IT_MANAGEMENT_COMPONENT.CITY]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  getCities(pageIndex?: string, pageSize?: string, otherParams?: object): void {
    this.loading = true;
    this.crudService.get(
      ModulesBasedApiSuffix.IT_MANAGEMENT,
      UserModuleApiSuffixModels.CITIES,
      undefined,
      false,
      prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.dataList = response.resources;
        this.totalRecords = response.totalCount;
        this.loading = false;
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  onCRUDRequested(type: CrudType | string, row?: object, searchObj?): void {
    switch (type) {
      case CrudType.CREATE:
        if (checkUserPermissionsByCategory(this, CrudType.CREATE)) {
          this.OpenDialogWindow(CrudType.CREATE, row);
        }
        break;
      case CrudType.GET:
        switch (this.selectedTabIndex) {
          case 0:
            this.getCities(row["pageIndex"], row["pageSize"], searchObj);
            break;
        }
        break;
      case CrudType.STATUS_POPUP:
        this.reusablePrimeNGTableFeatureService.openDynamicChangeStatusDialog(this.selectedTabIndex,
          this.primengTableConfigProperties, row)?.onClose?.subscribe((result) => {
            if (!result) {
              this.dataList[searchObj].isActive = this.dataList[searchObj].isActive ? false : true;
            }
          });
        break;
      case CrudType.VIEW:
        if (checkUserPermissionsByCategory.bind(this, CrudType.EDIT)) {
          this.OpenDialogWindow(CrudType.VIEW, row);
        }
        break;
    }
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  OpenDialogWindow(type: CrudType | string, city) {
    const dialogReff = this.dialog.open(CityAddEditComponent, { width: '450px', height: '450px', data: city ? city : {}, disableClose: true });
    dialogReff.afterClosed().subscribe(result => {
      if (result) {
        return
      }
      this.rxjsService.setDialogOpenProperty(false);
      this.getCities();
    });
  }
}
